import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <main
      style={{
        minHeight: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'clamp(48px, 8vw, 80px) clamp(16px, 5vw, 32px)',
        textAlign: 'center',
      }}
    >
      <div>
        <div
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 700,
            fontSize: '120px',
            color: 'rgba(200,169,110,0.08)',
            lineHeight: 1,
            marginBottom: '0',
            letterSpacing: '-4px',
          }}
        >
          404
        </div>
        <h1
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 700,
            fontSize: '36px',
            textTransform: 'uppercase',
            color: 'var(--cream)',
            marginTop: '-20px',
            marginBottom: '16px',
          }}
        >
          Page Not Found
        </h1>
        <p style={{ color: 'var(--muted)', marginBottom: '36px', maxWidth: '360px', margin: '0 auto 36px' }}>
          Looks like this page packed up and hit the road. Let's get you back to the show.
        </p>
        <Link to="/" className="btn-primary">
          Back to Home
        </Link>
      </div>
    </main>
  )
}
